var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 21.875,
    fill: "#FAFAFA",
    stroke: "#EAEAEA",
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6472 16.2497C25.8033 16.2497 25.9545 16.3067 26.0734 16.4257C26.3089 16.6611 26.3089 17.0403 26.0734 17.2782L20.4576 22.8941L26.0734 28.5075C26.3089 28.7429 26.3089 29.1246 26.0734 29.3625C25.838 29.5979 25.4563 29.5979 25.2184 29.3625L18.75 22.8941L25.2184 16.4257C25.3374 16.3092 25.491 16.2497 25.6472 16.2497Z",
    fill: "#343A40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBtn);
export default __webpack_public_path__ + "static/media/backBtn.0117b2ba567fddaafa3520f0492c8151.svg";
export { ForwardRef as ReactComponent };